function UserFeedback(aUserId, aUrl, aContent) {
    "use strict";
    this.__type = 'UserFeedback:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.UserId = aUserId;
    this.Url = aUrl;
    this.Content = aContent;
}
if (typeof exports !== 'undefined') {
    module.exports = UserFeedback;
}